import { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import PropTypes from 'prop-types';

import { Box, Link, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { useTransl } from 'shared/lib/i18n';

import NotFound from '../../res/svg/NotFound';
import { history } from '../../store';

const StyledContainer = styled(Box)(() => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

const Component404 = ({ location: { state } }) => {
  const { t } = useTransl();
  if (state && state.from && state.from === '/login') history.replace('./');

  useEffect(() => {
    document.title = t('errors.pageNotFound');
  }, []);

  return (
    <StyledContainer>
      <Box sx={{ padding: '2rem' }}>
        <NotFound />
      </Box>
      <Box sx={{ paddingBottom: '6rem' }}>
        <Typography variant="h3">{t('common.oops')}</Typography>
        <Typography variant="h6">{t('errors.cantFindPage')}</Typography>
        <Typography variant="h6">
          {t('errors.believeError')}
          <Link component={RouterLink} to="/support">
            {t('actions.contactUs')}
          </Link>
          .
        </Typography>
      </Box>
    </StyledContainer>
  );
};

Component404.propTypes = {
  location: PropTypes.instanceOf(Object).isRequired,
};

export default Component404;
